import "@babel/polyfill";
import $ from 'jquery';
import loader from './__modules/loader';
import burger_menu from './__modules/burger-menu';
import searchbar from "./__modules/searchbar";
import load_more_race_blogs from "./__modules/load-more-race-blogs";
import autoplay_slider from "./__modules/autoplay-slider";
import animated_number_counting from "./__modules/animated-number-counter";
import races_slider from "./__modules/races-slider";
import partner_slider from "./__modules/partners-slider";
import hero_slider from "./__modules/hero-slider";
import load_more_partners from "./__modules/load-more-partners";
import load_more_events from "./__modules/load-more-events";
import load_more_annual_reports from "./__modules/load-more-annual-reports";

document.addEventListener('DOMContentLoaded', () => {
	loader();
	burger_menu();
	searchbar();
	hero_slider();
	autoplay_slider();
	animated_number_counting();
	races_slider();
	partner_slider();
	load_more_partners();
	load_more_events();
	load_more_annual_reports();
});

window.addEventListener('load', () => {
	load_more_race_blogs();

});

window.addEventListener('resize', () => {
});

window.addEventListener('scroll', () => {
});

